<div *ngIf="isAuthenticated">
  Wifm Upload


  <!-- <div #dropzone class="drop-zone" (drop)="onDrop2($event)" (dragover)="onDragOver2($event)" (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)">

    <span *ngIf="files.length == 0">Drop one or more files</span>
    <span *ngIf="files.length == 0">to be uploaded </span>
    <span *ngIf="files.length > 0">Upload: {{getFileNames()}}</span>
    <span *ngIf="files.length == 0">or</span>
    <button *ngIf="files.length == 0" (click)="selectFile($event)" style="font-size: 14pt;">Select File</button>
    <input #fileBtn type="file" multiple hidden (change)="selectFileSubmit($event)" />
  </div> -->

  <!-- <input #fileBtn type="file" multiple (change)="selectFileSubmit($event)" /> -->

  <div webkitdirectory #dropzone class="drop-zone" (drop)="onDrop2($event)" (dragover)="onDragOver2($event)" (dragenter)="onDragEnter($event)"
    (dragleave)="onDragLeave($event)">

    <span *ngIf="files.length == 0">Drop one or more files</span>
    <span *ngIf="files.length == 0">to be uploaded </span>
    <span *ngIf="files.length > 0">Upload: {{getFileNames()}}</span>
    <span *ngIf="files.length == 0">or</span>
    <button *ngIf="files.length == 0" (click)="selectFile($event)" style="font-size: 14pt;">Select File</button>
    <input #fileBtn type="file" webkitdirectory hidden (change)="selectFileSubmit($event)" />
  </div>
  <div style="padding-top: 15px;">
    <button (click)="submit($event)" [disabled]="busySave">Start Upload</button>
    {{uploadMsg}}
    <br />
    {{getTimer()}}
  </div>





</div>